import { useBatchedSimpleUser } from "@/-dataloaders/simple-users"
import { PersonProfilePictureAvatar } from "../routes/app/-components/person-profile-picture-avatar"

interface Props {
  userId: number
}

export function UserAvatar({ userId }: Props) {
  const { data: user } = useBatchedSimpleUser(userId)
  return <PersonProfilePictureAvatar personId={user?.personId ?? 0} />
}
